import { axiosInstance } from '.';
import { AuthUser, User } from '../interfaces';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const register = async (data: User): Promise<any> => {
  const response = await axiosInstance.post('/auth/register', data);
  return response.data;
};

const login = async (email: string, password: string): Promise<AuthUser> => {
  const response = await axiosInstance.post('/auth/login', { email, password });
  return response.data;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const logout = async (): Promise<any> => {
  try {
    // If your backend has a logout endpoint, call it here
    // const response = await axiosInstance.post('/auth/logout');
    // return response.data;

    // For now, just return a successful promise
    return Promise.resolve({ success: true });
  } catch (error) {
    console.error('Error during server logout:', error);
    return Promise.resolve({ success: false, error });
  }
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const forgotPassword = async (email: string): Promise<any> => {
  const response = await axiosInstance.post('/auth/reset-password', { email });
  return response.data;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const verifyToken = async (token: string): Promise<any> => {
  const response = await axiosInstance.get(`/auth/verify-token?token=${token}`);
  return response.data;
};

const updatePassword = async (
  token: string,
  password: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<any> => {
  const response = await axiosInstance.post('/auth/update-password', {
    password,
    token,
  });
  return response.data;
};

const changePassword = async (
  email: string,
  currentPassword: string,
  newPassword: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<any> => {
  const response = await axiosInstance.post('/auth/change-password', {
    email,
    currentPassword,
    newPassword,
  });
  return response.data;
};

const updateProfile = async (data: Partial<User>): Promise<AuthUser> => {
  const response = await axiosInstance.put('/auth/profile', data);
  return response.data;
};

const getApiKey = async (): Promise<{ apiKey: string }> => {
  const response = await axiosInstance.get('/auth/api-key');
  return response.data;
};

const getCurrentUsage = async () => {
  const response = await axiosInstance.get('/usage/info');
  const data = {
    used: response.data.usage.current_month_attributions,
    total: response.data.usage.monthly_attribution_limit,
    percentage: response.data.usage.percentage_used,
    tier: response.data.usage.tier,
  };

  return data;
};

export const auth = {
  forgotPassword,
  login,
  logout,
  register,
  updatePassword,
  verifyToken,
  changePassword,
  updateProfile,
  getApiKey,
  getCurrentUsage,
};
